export const PromoModel = {
    desktop_banner: null,
    mobile_banner: null,
    title_promo: null,
    select_product: [],
    delete_product: []
}